/**
 * Shared option lists for the legal document form components.
 */

export const ROLE_OPTIONS = [
    { value: "all", label: "All" },
    { value: "artist", label: "Artist" },
    { value: "auditor", label: "Auditor" }
];

export const LANGUAGE_OPTIONS = [
    { value: "fr", label: "Français" },
    { value: "en", label: "English" }
];
